import Reveal from "@/components/base/Reveal";
import SectionTag from "@/components/base/SectionTag";
import { reportDirections, voices } from "@/mocks/content";

export default function TrustSection() {
  return (
    <section className="w-full bg-primary-950 py-20 md:py-28" id="trust">
      <div className="mx-auto w-full max-w-[1320px] px-5 md:px-8">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)] lg:gap-20">
          <div>
            <SectionTag tone="light">公开方向 · 提供者反馈</SectionTag>
            <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
              这些方向，我们已经持续跟进
            </h2>
            <p className="mt-4 text-sm leading-7 text-background-200/80 md:text-[15px]">
              我们不预设结论，只按公共价值排队。以下方向长期开放征集，也在持续接收补充材料与后续进展。
            </p>

            <div className="mt-8 flex flex-wrap gap-2.5">
              {reportDirections.map((item) => (
                <span
                  key={item}
                  className="rounded-full border border-background-50/20 bg-background-50/5 px-4 py-1.5 text-xs text-background-100"
                >
                  {item}
                </span>
              ))}
            </div>

            <div className="mt-10 flex items-center gap-4 border-t border-background-50/15 pt-8">
              <div className="flex -space-x-3">
                {["关", "线", "证"].map((word) => (
                  <span
                    key={word}
                    className="flex h-10 w-10 items-center justify-center rounded-full border border-primary-950 bg-accent-500 font-heading text-sm font-bold text-primary-950"
                  >
                    {word}
                  </span>
                ))}
              </div>
              <p className="text-xs leading-6 text-background-200/80">
                所有反馈均来自匿名提供者，身份信息已按约定处理。
              </p>
            </div>
          </div>

          <div className="space-y-5">
            {voices.map((voice, index) => (
              <Reveal key={voice.meta} delay={index * 90}>
                <blockquote className="rounded-lg border border-background-50/15 bg-background-50/5 p-6 md:p-7">
                  <i className="ri-double-quotes-l text-2xl text-accent-400"></i>
                  <p className="mt-3 text-sm leading-7 text-background-100 md:text-[15px] md:leading-8">
                    {voice.quote}
                  </p>
                  <footer className="mt-5 flex items-center gap-2 text-xs text-background-200/70">
                    <span className="h-px w-6 bg-accent-400/60"></span>
                    {voice.meta}
                  </footer>
                </blockquote>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}